@use 'tokens.module' as t;

.image {
  width: 180px;
  height: 180px;
  border-radius: var(--radius-inner) 0 0 var(--radius-inner);
}

.icon {
  align-items: center;
  background-color: hsl(0, 0%, 86%);
  display: flex;
  justify-content: center;
}

.player {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.player-main {
  align-items: center;
  display: flex;
  flex: 1 0 auto;
  flex-direction: row;
  padding: 20px 40px;
}

.info {
  display: flex;
  flex-basis: 100%;
  flex-direction: column;
  margin-left: 1rem;
}

.player-controls {
  border-top: 2px solid t.$grey-lighter;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 50px;
}

.play-button,
.rewind,
.forward {
  cursor: pointer;
  transition: ease-in-out background-color 0.1s;

  &:hover,
  &:focus {
    background-color: rgba(0, 0, 0, 0.1);
  }
}

.play-button {
  align-items: center;
  border: 2px solid t.$grey-lighter;
  border-radius: 45px;
  display: flex;
  height: 45px;
  justify-content: center;
  min-width: 45px;
  width: 45px;

  &--paused svg {
    margin-left: 3px;
  }
}

.rewind,
.forward {
  align-items: center;
  border-right: 2px solid t.$grey-lighter;
  display: flex;
  justify-content: center;
  width: 50px;
}

.forward {
  border: 0;
  border-left: 2px solid t.$grey-lighter;
}

.progress {
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 50px;
  width: 100%;

  > progress {
    cursor: pointer;
    margin: 0 !important;
    width: calc(100%);
  }

  > span {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    padding: 0 20px;
  }
}
